const bedc = [
	'bedc:country:read:{countryCode}',
	'bedc:country:lookup',
	'bedc:country:list',
] as const;

const integration = [
	'integration:country:read:{countryCode}',
	'integration:country:lookup',
] as const;

export default [...bedc, ...integration] as const;
